import React from 'react'
import { usePostRequest } from '../../../hooks/request'
import MarketForm from './MarketForm'

export default function MarketCreate({ onCancel, onSuccess }) {
    const brandCreate = usePostRequest({ url: '/main/market' })

    async function onSubmit(data) {
        const { success } = await brandCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Қўшиш</b>
            </h1>

            <MarketForm loading={brandCreate.loading} onSubmit={onSubmit} onCancel={onCancel} />
        </div>
    )
}
